import { render, staticRenderFns } from "./GoodsInfoDetail.vue?vue&type=template&id=f4743e32&scoped=true&"
import script from "./GoodsInfoDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodsInfoDetail.vue?vue&type=style&index=0&id=f4743e32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4743e32",
  null
  
)

export default component.exports